"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocalStorageHelper = /** @class */ (function () {
    function LocalStorageHelper() {
    }
    LocalStorageHelper.tryGetItem = function (key) {
        var resultStr = window.localStorage.getItem(key);
        if (resultStr) {
            var result = JSON.parse(resultStr);
            return result;
        }
        return null;
    };
    LocalStorageHelper.setItem = function (key, item) {
        var str = JSON.stringify(item);
        window.localStorage.setItem(key, str);
    };
    LocalStorageHelper.removeItem = function (key) {
        window.localStorage.removeItem(key);
    };
    return LocalStorageHelper;
}());
exports.LocalStorageHelper = LocalStorageHelper;
//# sourceMappingURL=LocalStorageHelper.js.map